import React from "react";
import { Avatar, Row, Col } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { Participant } from "types";
import { useTranslation } from "react-i18next";

interface ClassParticipantsProps {
  participants?: Participant[];
  className?: string;
}

export default function ClassParticipants({
  participants,
  className,
}: ClassParticipantsProps) {
  const { t } = useTranslation("class_banner");

  if (!participants || !participants.length) {
    return null;
  }

  const getRedirectLink = (link: string) => {
    const endpoint = link.split("/").pop();

    if (endpoint === "") {
      return "http://www.flexiclasses.com/student-has-no-forum-profile-yet";
    }

    return link;
  };

  return (
    <div className={className}>
      <div className="class-participants-title">{t("CLASS PARTICIPANTS")}</div>
      <Row>
        {participants.map(({ id, name, avatar, forumProfile }) => (
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={4}
            key={id}
            className="student-container"
          >
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={getRedirectLink(forumProfile)}
            >
              <Avatar
                src={avatar}
                size={40}
                icon={<UserOutlined />}
                className="student-avatar"
              />
              <span className="student-name">{name}</span>
            </a>
          </Col>
        ))}
      </Row>
    </div>
  );
}
